import type { AppMeta } from "@calcom/types/App";

import _package from "./package.json";

export const metadata = {
  name: "Autocheckin",
  description: _package.description,
  installed: true,
  category: "automation",
  categories: ["automation"],
  logo: "icon.svg",
  publisher: "Schedly",
  slug: "autocheckin",
  title: "Autocheckin",
  type: "autocheckin_automation",
  url: "https://schedly.io/apps/autocheckin",
  variant: "automation",
  email: "support@schedly.io",
  dirName: "autocheckin",
  isOAuth: false,
} as AppMeta;

export default metadata;
